// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oCLRXCkmNF {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.oCLRXCkmNF h4 {
  line-height: 3em;
}
.oCLRXCkmNF ._hq8JlBGV4 {
  float: left;
  width: 100%;
}
.oCLRXCkmNF .ZJlFUi69Fq {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.oCLRXCkmNF .ZJlFUi69Fq:hover {
  cursor: pointer;
}
.oCLRXCkmNF .ZJlFUi69Fq:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.YTAUJrcHYg .G_R3UDNppv:focus {
  outline: none;
}
.YTAUJrcHYg .G_R3UDNppv.bPPnvbc9Xw.r9e5HqsFqQ {
  background: #375A88;
}
.YTAUJrcHYg .G_R3UDNppv.bPPnvbc9Xw.r9e5HqsFqQ span {
  color: #fff;
}
.YTAUJrcHYg .r9e5HqsFqQ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.YTAUJrcHYg .r9e5HqsFqQ:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.YTAUJrcHYg input {
  height: 38px;
  min-width: 220px;
}
.ZJlFUi69Fq.keas8VYm3G {
  background: #410102;
}
.ZJlFUi69Fq.xKl6XjS92f {
  background: #911318;
}
.ZJlFUi69Fq.x348m5K7xt {
  background: #D8293B;
}
.ZJlFUi69Fq.lxtYQgxtmh {
  background: #F2373C;
}
.ZJlFUi69Fq.X8CeXVWyJ0 {
  background: #FC4448;
}
.ZJlFUi69Fq.RTUGcUBQMy {
  background: #ED535E;
}
.ZJlFUi69Fq.h9gAFBn8tc {
  background: #E34926;
}
.ZJlFUi69Fq.Ztbaiih7P2 {
  background: #FC562B;
}
.ZJlFUi69Fq.z8loWfed6F {
  background: #FC6722;
}
.ZJlFUi69Fq.PqZVq0GKnL {
  background: #FD7F24;
}
.ZJlFUi69Fq.zQO4xZvDFj {
  background: #FD8D26;
}
.ZJlFUi69Fq.oUlEoPrfj8 {
  background: #EC9C3E;
}
.ZJlFUi69Fq.tTIiJ6fdkv {
  background: #0e673a;
}
.ZJlFUi69Fq.BYsKoOdrsJ {
  background: #208740;
}
.ZJlFUi69Fq.B5yMbz2Qn4 {
  background: #239718;
}
.ZJlFUi69Fq.d6fvaswZFz {
  background: #55A84D;
}
.ZJlFUi69Fq.v0POU89XmP {
  background: #4BBE5A;
}
.ZJlFUi69Fq.kykWo5ssvo {
  background: #0CCA6A;
}
.ZJlFUi69Fq.aJD9pvQKBk {
  background: #0A3C64;
}
.ZJlFUi69Fq.WtLylWkcfg {
  background: #0d487a;
}
.ZJlFUi69Fq.Qe67qgmJjP {
  background: #10538d;
}
.ZJlFUi69Fq.xIOvzaL2h4 {
  background: #115A99;
}
.ZJlFUi69Fq.hp0gMw777l {
  background: #3387E2;
}
.ZJlFUi69Fq.FMJooEwwmO {
  background: #1BA9CF;
}
.ZJlFUi69Fq.M1ZgTDRNOJ {
  background: #d27c02;
}
.ZJlFUi69Fq.A5pcKKwKWK {
  background: #fb9402;
}
.ZJlFUi69Fq.ZRkgQIzahh {
  background: #FD9B30;
}
.ZJlFUi69Fq.i1UYF6UIhv {
  background: #FDBE2D;
}
.ZJlFUi69Fq.aDYllOB8ig {
  background: #FED831;
}
.ZJlFUi69Fq.o7RTKG2PGx {
  background: #FFFD38;
}
.ZJlFUi69Fq.eiXJuRzmbb {
  background: #2D215C;
}
.ZJlFUi69Fq.lwLYOD6CqW {
  background: #483C83;
}
.ZJlFUi69Fq.Ew1cWKDTu9 {
  background: #58518d;
}
.ZJlFUi69Fq.PcNfJHn795 {
  background: #7068A9;
}
.ZJlFUi69Fq.sDWPFgMZKn {
  background: #7f78b2;
}
.ZJlFUi69Fq.NSkzfVFexD {
  background: #8f88bc;
}
.ZJlFUi69Fq.jH7vM_HXkh {
  background: #000;
}
.ZJlFUi69Fq.yZn1V6TCLC {
  background: #282626;
}
.ZJlFUi69Fq.ElwHWI8B2D {
  background: #242222;
}
.ZJlFUi69Fq.pYzYioW50Z {
  background: #353838;
}
.ZJlFUi69Fq.zaZiyev8g4 {
  background: #666;
}
.ZJlFUi69Fq.xJtb2fkRFs {
  background: #999;
}
.JkdsybytRp {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.JkdsybytRp .E0xFCuOPGc {
  display: none;
}
.s6ZPjeoVes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 20px;
}
.s6ZPjeoVes .ATAoByMBqz {
  font-size: 15px;
  text-transform: uppercase;
}
.s6ZPjeoVes .Ep4XX7UF3y {
  display: flex;
}
.s6ZPjeoVes .Ep4XX7UF3y .Uc4kztyTZi {
  max-height: 16px;
  cursor: pointer;
  border-bottom: 1px solid #707070;
  margin-left: 20px;
}
.s6ZPjeoVes .Ep4XX7UF3y .Uc4kztyTZi .mlbcgl5wNi,
.s6ZPjeoVes .Ep4XX7UF3y .Uc4kztyTZi .Xctpn2CmTM {
  font-size: 11px;
}
.s6ZPjeoVes .Ep4XX7UF3y .Uc4kztyTZi .Xctpn2CmTM {
  margin-left: 8px;
  text-transform: capitalize;
}
.PIuUQ4goSy {
  background-color: #F5F6FA;
  font-size: 12px;
  padding: 24px 0;
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `oCLRXCkmNF`,
	"color-row": `_hq8JlBGV4`,
	"color-tile": `ZJlFUi69Fq`,
	"picker-component": `YTAUJrcHYg`,
	"picker-element": `G_R3UDNppv`,
	"active": `bPPnvbc9Xw`,
	"btn": `r9e5HqsFqQ`,
	"red-1": `keas8VYm3G`,
	"red-2": `xKl6XjS92f`,
	"red-3": `x348m5K7xt`,
	"red-4": `lxtYQgxtmh`,
	"red-5": `X8CeXVWyJ0`,
	"red-6": `RTUGcUBQMy`,
	"orange-1": `h9gAFBn8tc`,
	"orange-2": `Ztbaiih7P2`,
	"orange-3": `z8loWfed6F`,
	"orange-4": `PqZVq0GKnL`,
	"orange-5": `zQO4xZvDFj`,
	"orange-6": `oUlEoPrfj8`,
	"green-1": `tTIiJ6fdkv`,
	"green-2": `BYsKoOdrsJ`,
	"green-3": `B5yMbz2Qn4`,
	"green-4": `d6fvaswZFz`,
	"green-5": `v0POU89XmP`,
	"green-6": `kykWo5ssvo`,
	"blue-1": `aJD9pvQKBk`,
	"blue-2": `WtLylWkcfg`,
	"blue-3": `Qe67qgmJjP`,
	"blue-4": `xIOvzaL2h4`,
	"blue-5": `hp0gMw777l`,
	"blue-6": `FMJooEwwmO`,
	"yellow-1": `M1ZgTDRNOJ`,
	"yellow-2": `A5pcKKwKWK`,
	"yellow-3": `ZRkgQIzahh`,
	"yellow-4": `i1UYF6UIhv`,
	"yellow-5": `aDYllOB8ig`,
	"yellow-6": `o7RTKG2PGx`,
	"purple-1": `eiXJuRzmbb`,
	"purple-2": `lwLYOD6CqW`,
	"purple-3": `Ew1cWKDTu9`,
	"purple-4": `PcNfJHn795`,
	"purple-5": `sDWPFgMZKn`,
	"purple-6": `NSkzfVFexD`,
	"black-1": `jH7vM_HXkh`,
	"black-2": `yZn1V6TCLC`,
	"black-3": `ElwHWI8B2D`,
	"black-4": `pYzYioW50Z`,
	"black-5": `zaZiyev8g4`,
	"black-6": `xJtb2fkRFs`,
	"picker-theme": `JkdsybytRp`,
	"arrow-regular": `E0xFCuOPGc`,
	"reviewTicket-grid___header": `s6ZPjeoVes`,
	"grid-header__title": `ATAoByMBqz`,
	"review-ticket__actions": `Ep4XX7UF3y`,
	"grid_createReview__btn": `Uc4kztyTZi`,
	"create-btn__icon": `mlbcgl5wNi`,
	"create-btn__text": `Xctpn2CmTM`,
	"empty-review__root": `PIuUQ4goSy`
};
export default ___CSS_LOADER_EXPORT___;
